document.querySelectorAll(".product-media__gallery.js").forEach(section => {
  section.classList.remove("js");
  const galleryThumbsElement = section.querySelector(".gallery-thumbs");
  const galleryMainElement = section.querySelector(".gallery-main");
  const swiperPagination = section.querySelector(".swiper-pagination");
  const swiperButtonNext = section.querySelector(".swiper-button-next");
  const swiperButtonPrev = section.querySelector(".swiper-button-prev");

  const galleryThumbs = new Swiper(galleryThumbsElement, {
    slidesPerView: "auto",
    spaceBetween: 16,
  });

  const galleryMain = new Swiper(galleryMainElement, {
    slidesPerView: 1.15,
    grabCursor: true,
    centeredSlides: true,
    spaceBetween: 12,
    mousewheel: {
        forceToAxis: true
    },
    navigation: {
      nextEl: swiperButtonNext,
      prevEl: swiperButtonPrev,
    },
    pagination: {
      el: swiperPagination,
      clickable: true,
    },
    thumbs: {
      swiper: galleryThumbs
    },
    breakpoints: {
      750: {
        slidesPerView: "auto",
        spaceBetween: 20,
        simulateTouch: true,
      },
    },
  });
  if (window.innerWidth <= 750) {
    galleryMain.slideTo(1);
  }

  const variantSelectsContainer = document.querySelector('.product__variant');
  if (variantSelectsContainer) {
    variantSelectsContainer.addEventListener('click', function(event) {
      const label = event.target.closest('label');
      if (label) {
        const selectedText = label.firstChild.textContent.trim();
        const slides = galleryMain.slides;
        let matchedSlide = null;
        let indexSlide = null;

        slides.forEach((slide, index) => {
          const img = slide.querySelector('img');
          if (img && img.alt.includes(selectedText)) {
            matchedSlide = slide;
            indexSlide = index;
          }
        });

        if (matchedSlide) {
          galleryMain.slideTo(indexSlide);
        }
      }
    });
  }
});

